import { createSlice } from '@reduxjs/toolkit';

const syncLeadDefaults = {
  referenceIdQueryParam: '',
};

export const syncLeadSlice = createSlice({
  name: 'syncLead',
  initialState: syncLeadDefaults,
  reducers: {
    setReferenceIdQueryParam: (state, action) => {
      state.referenceIdQueryParam = action.payload;
    },
  },
});

export const { setReferenceIdQueryParam } = syncLeadSlice.actions;
export default syncLeadSlice.reducer;
